'use client';
import Link from '@/components/WrappedLink';
import {
    Ar200,
    Ar7,
    Ar90,
    ArPercentage,
    ArrowRightDark,
    En200,
    En7,
    En90,
    EnPercentage,
} from '../../../../public/Images';
import { AVAILABLE_LANGUAGES } from '@/constants';
import myImageLoader from '@/image.local.loader';
import CarouselV2 from '@/components/shared/carouselv2/carouselv2.component';
import Typography from '@/components/shared/typography/typography.component';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';

interface IValuePropositionMobileProps {
    lang: AVAILABLE_LANGUAGES;
}
const ValuePropositionMobile = ({ lang }: IValuePropositionMobileProps) => {
    const Slide1Imgs =
        lang === AVAILABLE_LANGUAGES.ar
            ? [ArPercentage, Ar7]
            : [EnPercentage, En7];
    const { t } = useTranslation();

    const Slide2Imgs =
        lang === AVAILABLE_LANGUAGES.ar ? [Ar90, Ar200] : [En90, En200];

    return (
        <div
            className={
                'border-gray-200 py-6 border-t border-b border-solid lg:py-0 lg:border-0'
            }
        >
            <div className={' block'}>
                <div className={'flex justify-between relative'}>
                    <Typography
                        variant={'subtitle1Bold'}
                        className={'text-gray-500'}
                    >
                        {t('Sylndr Certified')}
                    </Typography>
                    <Link
                        className={
                            'cursor-pointer no-underline flex gap-1 items-center'
                        }
                        href={`/${lang}/why-sylndr`}
                    >
                        <Typography
                            style={{ marginTop: '2px' }}
                            variant={'captionMedium'}
                            className={'text-gray-500'}
                        >
                            {t('Why Sylndr')}
                        </Typography>
                        <Image
                            className={'ar:-scale-x-100'}
                            src={ArrowRightDark.src}
                            width={20}
                            height={20}
                            alt={'right'}
                        />
                    </Link>
                </div>
                <Typography variant={'caption'} className={'text-gray-500'}>
                    {t('Buy verified car')}
                </Typography>
            </div>

            <CarouselV2
                showDots={false}
                autoPlay={false}
                frameDuration={3000}
                showArrows={true}
            >
                <div className={'gap-2 flex w-full justify-start mt-2 lg:mt-0'}>
                    {Slide1Imgs?.map((img, index) => {
                        return (
                            <Link
                                key={img.src + index}
                                className={'flex w-1/2 '}
                                href={`/${lang}/why-sylndr`}
                            >
                                <img
                                    src={myImageLoader({
                                        src: img.src,
                                        width: 636,
                                        height: 860,
                                        quality: 75,
                                    })}
                                    loading={'lazy'}
                                    fetchPriority={'low'}
                                    alt={'value ' + index}
                                    className={
                                        'object-contain inline-block cursor-pointer box-border p-0 rounded-[4%] w-[45vw] max-w-[45vw] h-auto lg:w-full lg:max-w-full'
                                    }
                                />
                            </Link>
                        );
                    })}
                </div>

                <div className={'gap-2 flex w-full justify-start mt-2 lg:mt-0'}>
                    {Slide2Imgs?.map((img, index) => {
                        return (
                            <Link
                                key={img.src + index}
                                className={'flex w-1/2 '}
                                href={`/${lang}/why-sylndr`}
                            >
                                <img
                                    src={myImageLoader({
                                        src: img.src,
                                        width: 636,
                                        height: 860,
                                        quality: 75,
                                    })}
                                    loading={'lazy'}
                                    fetchPriority={'low'}
                                    alt={'value ' + index}
                                    className={
                                        'object-contain inline-block cursor-pointer box-border p-0 rounded-[4%] w-[45vw] max-w-[45vw] h-auto lg:w-full lg:max-w-full'
                                    }
                                />
                            </Link>
                        );
                    })}
                </div>
            </CarouselV2>
        </div>
    );
};

export default ValuePropositionMobile;
